import Vue from 'vue'
import { has } from 'lodash'
import store from 'vx/store'
import { DEFAULT_REDIRECT, notify } from 'utils'

const showPermissionError = (msg = 'You do not have the necessary permission to perform this action.') => notify.error(msg)

export default (to, from, next) => {
  const { authorized } = store.state.user
  const can = store.getters['user/can']
  const cannot = store.getters['user/cannot']

  if (has(to.meta, 'can')) {
    if (typeof to.meta.can === 'function') {
      if (!to.meta.can(can, to, from)) {
        showPermissionError()

        next(DEFAULT_REDIRECT[authorized.role])

        return
      }
    } else if (cannot(to.meta.can)) {
      showPermissionError()
      next(DEFAULT_REDIRECT[authorized.role] ?? { path: '/' })

      return
    }
  }
  next()
}
